// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container matching Dashboard gradient */
.admin-members-container {
    min-height: 100vh;
    background: linear-gradient(135deg, #f8fafc 0%, #eef2f6 100%);
    font-family: inherit;
    display: flex;
    flex-direction: column;
}

.center-content {
    justify-content: center;
    align-items: center;
}

.loading-text {
    margin-top: 1.5rem;
    font-size: 1.2rem;
    color: #475569;
    font-weight: 500;
}

/* === HEADER === */
.groups-header {
    margin-bottom: 1.5rem;
}

.elder-back-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: white;
    border: 1px solid #cbd5e1;
    padding: 0.6rem 1rem;
    border-radius: 10px;
    font-size: 1rem;
    font-weight: 600;
    color: #334155;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.elder-back-btn:hover {
    background: #f1f5f9;
    border-color: #94a3b8;
    color: #1e293b;
}

.page-title {
    margin: 0;
    font-size: 1.5rem;
    color: #1e293b;
    font-weight: 800;
}

/* === MAIN CONTENT === */
.members-main-content {
    padding: 0 2rem 4rem 2rem;
    max-width: 1000px;
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;
}

/* === CONTROL PANEL (Search) === */
.members-control-panel {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 2.5rem;
    background: white;
    padding: 1rem;
    border-radius: 16px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(226, 232, 240, 0.8);
}

.admin-search-form {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex: 1 1;
    max-width: 500px;
}

.admin-search-input-wrapper {
    display: flex;
    align-items: center;
    flex: 1 1;
    background: white;
    border: 1px solid #cbd5e1;
    border-radius: 10px;
    padding: 0 0.75rem;
    transition: border-color 0.2s, box-shadow 0.2s;
}

.admin-search-input-wrapper:focus-within {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.admin-search-icon {
    color: #94a3b8;
    flex-shrink: 0;
}

.admin-search-input {
    flex: 1 1;
    border: none;
    background: transparent;
    padding: 0.75rem 0.5rem;
    font-size: 1rem;
    color: #1e293b;
    outline: none;
    min-width: 0;
}

.admin-search-submit-btn {
    background: #3b82f6;
    color: white;
    border: none;
    padding: 0.75rem 1.25rem;
    border-radius: 10px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s;
    flex-shrink: 0;
}

.admin-search-submit-btn:hover {
    background: #2563eb;
}

/* === LIST SECTION === */
.section-header-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.25rem;
    flex-wrap: wrap;
    gap: 0.75rem;
}

.elder-section-title {
    font-size: 1.4rem;
    color: #1e293b;
    font-weight: 700;
    margin: 0;
    padding-left: 0.25rem;
}

.total-count-badge {
    background: #f1f5f9;
    color: #475569;
    padding: 0.4rem 1rem;
    border-radius: 99px;
    font-weight: 700;
    font-size: 0.9rem;
    border: 1px solid #e2e8f0;
    white-space: nowrap;
}

.elder-list-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.elder-list-card {
    background: white;
    border-radius: 16px;
    padding: 1.5rem;
    border: 1px solid rgba(226, 232, 240, 0.8);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1.5rem;
    transition: all 0.2s ease;
}

.clickable-card {
    cursor: pointer;
}

.clickable-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);
    border-color: #bfdbfe;
}

.clickable-card:hover .view-details-btn {
    color: #2563eb;
}

.clickable-card:hover .view-details-btn svg {
    transform: translateX(4px);
}

.list-card-left {
    display: flex;
    align-items: center;
    gap: 1.25rem;
    flex: 1 1;
    min-width: 0;
}

.icon-wrapper {
    height: 56px;
    width: 56px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.icon-slate {
    background: #f1f5f9;
    color: #475569;
}

.icon-emerald {
    background: #dcfce7;
    color: #059669;
}

.list-card-info {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    flex: 1 1;
    min-width: 0;
}

.title-with-status {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex-wrap: wrap;
}

.elder-card-title {
    margin: 0;
    font-size: 1.25rem;
    color: #1e293b;
    font-weight: 700;
    word-break: break-word;
}

.status-badge {
    font-size: 0.75rem;
    padding: 0.2rem 0.6rem;
    border-radius: 99px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.badge-success {
    background: #dcfce7;
    color: #15803d;
}

.badge-warning {
    background: #fef3c7;
    color: #b45309;
}

.badge-error {
    background: #fee2e2;
    color: #b91c1c;
}

.badge-slate {
    background: #f1f5f9;
    color: #475569;
    border: 1px solid #cbd5e1;
}

.person-details-inline {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
}

.detail-text {
    font-size: 1.05rem;
    color: #64748b;
    font-weight: 500;
}

.stat-divider {
    color: #cbd5e1;
}

/* Actions Right Side */
.list-card-right {
    flex-shrink: 0;
}

.view-details-btn {
    background: transparent;
    border: none;
    color: #64748b;
    font-size: 1.05rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
    transition: color 0.2s;
}

.view-details-btn svg {
    transition: transform 0.2s;
}

/* Empty States & Loading */
.elder-empty-card {
    background: white;
    border-radius: 16px;
    padding: 4rem 2rem;
    text-align: center;
    font-size: 1.2rem;
    color: #64748b;
    border: 2px dashed #cbd5e1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
}

.empty-icon-wrapper {
    height: 80px;
    width: 80px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
}

/* === PAGINATION === */
.elder-pagination {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 2rem;
    background: white;
    padding: 1rem 1.5rem;
    border-radius: 16px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(226, 232, 240, 0.8);
}

.page-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: #f1f5f9;
    border: none;
    color: #334155;
    padding: 0.75rem 1.25rem;
    border-radius: 12px;
    font-size: 1.1rem;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s;
}

.page-btn:hover:not(:disabled) {
    background: #e2e8f0;
    color: #1e293b;
}

.page-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}


/* =========================================
   === MEMBER DETAILS PAGE STYLES ===
   ========================================= */

.details-top-grid {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 1.5rem;
    margin-bottom: 2.5rem;
}

.profile-summary-card {
    background: white;
    border-radius: 16px;
    padding: 2rem;
    border: 1px solid #e2e8f0;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 1rem;
}

.profile-avatar {
    height: 90px;
    width: 90px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.profile-info h2 {
    margin: 0 0 0.25rem 0;
    font-size: 1.5rem;
    color: #1e293b;
    font-weight: 800;
}

.phone-text {
    margin: 0 0 1rem 0;
    color: #64748b;
    font-size: 1.1rem;
    font-weight: 500;
}

.global-stats-card {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
    width: 100%;
}

.stat-box {
    background: white;
    border-radius: 16px;
    padding: 1.25rem;
    border: 1px solid #e2e8f0;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
    display: flex;
    align-items: center;
    gap: 1.25rem;
}

/* Net Position Custom Colors */
.bg-red-light {
    background: #fef2f2;
}

.bg-emerald-light {
    background: #ecfdf5;
}

.border-emerald {
    border-color: #a7f3d0;
}

.border-red {
    border-color: #fecaca;
}

.stat-box .stat-icon {
    height: 56px;
    width: 56px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.stat-text p {
    margin: 0 0 0.25rem 0;
    color: #64748b;
    font-size: 1rem;
    font-weight: 600;
}

.stat-text h3 {
    margin: 0;
    font-size: 1.6rem;
    color: #1e293b;
    font-weight: 800;
}

.section-heading {
    font-size: 1.4rem;
    color: #1e293b;
    font-weight: 800;
    margin: 0 0 1.5rem 0;
}

.admin-divider {
    height: 1px;
    background: #cbd5e1;
    margin: 0 0 2.5rem 0;
}

.group-details-list {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.detailed-group-card {
    background: white;
    border-radius: 16px;
    padding: 1.5rem;
    border: 1px solid #e2e8f0;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
}

.group-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 1.25rem;
    border-bottom: 1px solid #f1f5f9;
    margin-bottom: 1.25rem;
}

.group-header-info h3 {
    margin: 0 0 0.5rem 0;
    font-size: 1.3rem;
    color: #1e293b;
    font-weight: 800;
}

.group-header-meta {
    display: flex;
    gap: 0.5rem;
}

.meta-pill {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    color: #475569;
    padding: 0.3rem 0.8rem;
    border-radius: 8px;
    font-size: 0.9rem;
    font-weight: 600;
}

.group-financial-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1rem;
    margin-bottom: 1.5rem;
}

.fin-box {
    background: #f8fafc;
    padding: 1rem;
    border-radius: 12px;
    border: 1px solid #f1f5f9;
}

.fin-box p {
    margin: 0 0 0.25rem 0;
    font-size: 0.9rem;
    color: #64748b;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 0.25rem;
}

.fin-box h4 {
    margin: 0;
    font-size: 1.2rem;
    color: #1e293b;
    font-weight: 800;
}

.alert-box {
    background: #fef2f2;
    border-color: #fecaca;
}

.success-box {
    background: #f0fdf4;
    border-color: #bbf7d0;
}

.text-red {
    color: #dc2626;
}

.text-blue {
    color: #2563eb;
}

.text-emerald {
    color: #059669;
}

.toggle-history-btn {
    width: 100%;
    background: white;
    border: 1px solid #cbd5e1;
    color: #475569;
    padding: 0.75rem;
    border-radius: 10px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    transition: all 0.2s;
}

.toggle-history-btn:hover {
    background: #f8fafc;
    color: #1e293b;
}

.group-history-section {
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid #f1f5f9;
}

.no-history-text {
    text-align: center;
    color: #94a3b8;
    font-style: italic;
    padding: 1rem;
}

.mini-history-list {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.mini-tx-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f8fafc;
    padding: 1rem;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
}

.mini-tx-left {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.mini-icon {
    height: 36px;
    width: 36px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.bg-blue-light {
    background: #eff6ff;
}

.bg-green-light {
    background: #f0fdf4;
}

.mini-tx-info p {
    margin: 0;
}

.tx-type {
    font-weight: 700;
    color: #1e293b;
    font-size: 1.05rem;
    margin-bottom: 0.2rem !important;
}

.tx-meta {
    color: #64748b;
    font-size: 0.85rem;
}

.italic {
    font-style: italic;
    margin-top: 0.2rem !important;
}

.mini-tx-right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    font-size: 1.2rem;
    font-weight: 800;
}

.pay-mode {
    font-size: 0.75rem;
    color: #94a3b8;
    background: white;
    padding: 0.1rem 0.5rem;
    border-radius: 4px;
    border: 1px solid #e2e8f0;
    margin-top: 0.25rem;
    font-weight: 600;
}

/* === RESPONSIVE FOR MOBILE === */
@media (max-width: 900px) {
    .details-top-grid {
        grid-template-columns: 1fr;
    }

    .group-financial-grid {
        grid-template-columns: 1fr 1fr;
    }
}

@media (max-width: 768px) {
    .groups-header {
        padding: 1.25rem;
    }

    .members-main-content {
        padding: 0 1rem 3rem 1rem;
    }

    .members-control-panel {
        justify-content: stretch;
    }

    .admin-search-form {
        max-width: 100%;
        width: 100%;
    }

    .elder-list-card {
        flex-direction: column;
        align-items: stretch;
        padding: 1.25rem;
        gap: 1.25rem;
    }

    .list-card-left {
        width: 100%;
    }

    .list-card-right {
        width: 100%;
        border-top: 1px solid #f1f5f9;
        padding-top: 1.25rem;
    }

    .view-details-btn {
        width: 100%;
        justify-content: space-between;
    }

    .elder-pagination {
        flex-direction: column;
        gap: 1.5rem;
    }

    .page-btn {
        width: 100%;
        justify-content: center;
    }

    /* Member Details Mobile */
    .global-stats-card {
        grid-template-columns: 1fr;
        /* Stack vertically on small phones */
    }

    .group-card-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;
    }

    .group-financial-grid {
        grid-template-columns: 1fr;
    }

    .mini-tx-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;
    }

    .mini-tx-right {
        width: 100%;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid #e2e8f0;
        padding-top: 0.75rem;
    }

    .pay-mode {
        margin-top: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/Members.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;IACI,iBAAiB;IACjB,6DAA6D;IAC7D,oBAAoB;IACpB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA,yBAAyB;AACzB;IACI,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,sBAAsB;AAC1B;;AAEA,mCAAmC;AACnC;IACI,aAAa;IACb,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,8CAA8C;IAC9C,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAO;IACP,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,0CAA0C;IAC1C,8CAA8C;IAC9C,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,gDAAgD;IAChD,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA,uBAAuB;AACvB;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,2BAA2B;AAC3B;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,8CAA8C;IAC9C,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,wBAAwB;IACxB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;;AAGA;;8CAE8C;;AAE9C;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,8CAA8C;IAC9C,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,8CAA8C;IAC9C,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA,+BAA+B;AAC/B;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,kCAAkC;AAClC;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;QACpB,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,6BAA6B;QAC7B,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,8BAA8B;IAClC;;IAEA;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,WAAW;QACX,uBAAuB;IAC3B;;IAEA,0BAA0B;IAC1B;QACI,0BAA0B;QAC1B,qCAAqC;IACzC;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,8BAA8B;QAC9B,mBAAmB;QACnB,6BAA6B;QAC7B,oBAAoB;IACxB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":["/* Container matching Dashboard gradient */\n.admin-members-container {\n    min-height: 100vh;\n    background: linear-gradient(135deg, #f8fafc 0%, #eef2f6 100%);\n    font-family: inherit;\n    display: flex;\n    flex-direction: column;\n}\n\n.center-content {\n    justify-content: center;\n    align-items: center;\n}\n\n.loading-text {\n    margin-top: 1.5rem;\n    font-size: 1.2rem;\n    color: #475569;\n    font-weight: 500;\n}\n\n/* === HEADER === */\n.groups-header {\n    margin-bottom: 1.5rem;\n}\n\n.elder-back-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    background: white;\n    border: 1px solid #cbd5e1;\n    padding: 0.6rem 1rem;\n    border-radius: 10px;\n    font-size: 1rem;\n    font-weight: 600;\n    color: #334155;\n    cursor: pointer;\n    transition: all 0.2s;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.elder-back-btn:hover {\n    background: #f1f5f9;\n    border-color: #94a3b8;\n    color: #1e293b;\n}\n\n.page-title {\n    margin: 0;\n    font-size: 1.5rem;\n    color: #1e293b;\n    font-weight: 800;\n}\n\n/* === MAIN CONTENT === */\n.members-main-content {\n    padding: 0 2rem 4rem 2rem;\n    max-width: 1000px;\n    margin: 0 auto;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n/* === CONTROL PANEL (Search) === */\n.members-control-panel {\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 2.5rem;\n    background: white;\n    padding: 1rem;\n    border-radius: 16px;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n    border: 1px solid rgba(226, 232, 240, 0.8);\n}\n\n.admin-search-form {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    flex: 1;\n    max-width: 500px;\n}\n\n.admin-search-input-wrapper {\n    display: flex;\n    align-items: center;\n    flex: 1;\n    background: white;\n    border: 1px solid #cbd5e1;\n    border-radius: 10px;\n    padding: 0 0.75rem;\n    transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.admin-search-input-wrapper:focus-within {\n    border-color: #3b82f6;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.admin-search-icon {\n    color: #94a3b8;\n    flex-shrink: 0;\n}\n\n.admin-search-input {\n    flex: 1;\n    border: none;\n    background: transparent;\n    padding: 0.75rem 0.5rem;\n    font-size: 1rem;\n    color: #1e293b;\n    outline: none;\n    min-width: 0;\n}\n\n.admin-search-submit-btn {\n    background: #3b82f6;\n    color: white;\n    border: none;\n    padding: 0.75rem 1.25rem;\n    border-radius: 10px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.2s;\n    flex-shrink: 0;\n}\n\n.admin-search-submit-btn:hover {\n    background: #2563eb;\n}\n\n/* === LIST SECTION === */\n.section-header-flex {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1.25rem;\n    flex-wrap: wrap;\n    gap: 0.75rem;\n}\n\n.elder-section-title {\n    font-size: 1.4rem;\n    color: #1e293b;\n    font-weight: 700;\n    margin: 0;\n    padding-left: 0.25rem;\n}\n\n.total-count-badge {\n    background: #f1f5f9;\n    color: #475569;\n    padding: 0.4rem 1rem;\n    border-radius: 99px;\n    font-weight: 700;\n    font-size: 0.9rem;\n    border: 1px solid #e2e8f0;\n    white-space: nowrap;\n}\n\n.elder-list-container {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.elder-list-card {\n    background: white;\n    border-radius: 16px;\n    padding: 1.5rem;\n    border: 1px solid rgba(226, 232, 240, 0.8);\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1.5rem;\n    transition: all 0.2s ease;\n}\n\n.clickable-card {\n    cursor: pointer;\n}\n\n.clickable-card:hover {\n    transform: translateY(-3px);\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);\n    border-color: #bfdbfe;\n}\n\n.clickable-card:hover .view-details-btn {\n    color: #2563eb;\n}\n\n.clickable-card:hover .view-details-btn svg {\n    transform: translateX(4px);\n}\n\n.list-card-left {\n    display: flex;\n    align-items: center;\n    gap: 1.25rem;\n    flex: 1;\n    min-width: 0;\n}\n\n.icon-wrapper {\n    height: 56px;\n    width: 56px;\n    border-radius: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.icon-slate {\n    background: #f1f5f9;\n    color: #475569;\n}\n\n.icon-emerald {\n    background: #dcfce7;\n    color: #059669;\n}\n\n.list-card-info {\n    display: flex;\n    flex-direction: column;\n    gap: 0.35rem;\n    flex: 1;\n    min-width: 0;\n}\n\n.title-with-status {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    flex-wrap: wrap;\n}\n\n.elder-card-title {\n    margin: 0;\n    font-size: 1.25rem;\n    color: #1e293b;\n    font-weight: 700;\n    word-break: break-word;\n}\n\n.status-badge {\n    font-size: 0.75rem;\n    padding: 0.2rem 0.6rem;\n    border-radius: 99px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.badge-success {\n    background: #dcfce7;\n    color: #15803d;\n}\n\n.badge-warning {\n    background: #fef3c7;\n    color: #b45309;\n}\n\n.badge-error {\n    background: #fee2e2;\n    color: #b91c1c;\n}\n\n.badge-slate {\n    background: #f1f5f9;\n    color: #475569;\n    border: 1px solid #cbd5e1;\n}\n\n.person-details-inline {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n}\n\n.detail-text {\n    font-size: 1.05rem;\n    color: #64748b;\n    font-weight: 500;\n}\n\n.stat-divider {\n    color: #cbd5e1;\n}\n\n/* Actions Right Side */\n.list-card-right {\n    flex-shrink: 0;\n}\n\n.view-details-btn {\n    background: transparent;\n    border: none;\n    color: #64748b;\n    font-size: 1.05rem;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    cursor: pointer;\n    transition: color 0.2s;\n}\n\n.view-details-btn svg {\n    transition: transform 0.2s;\n}\n\n/* Empty States & Loading */\n.elder-empty-card {\n    background: white;\n    border-radius: 16px;\n    padding: 4rem 2rem;\n    text-align: center;\n    font-size: 1.2rem;\n    color: #64748b;\n    border: 2px dashed #cbd5e1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 1rem;\n}\n\n.empty-icon-wrapper {\n    height: 80px;\n    width: 80px;\n    border-radius: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 1rem;\n}\n\n/* === PAGINATION === */\n.elder-pagination {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 2rem;\n    background: white;\n    padding: 1rem 1.5rem;\n    border-radius: 16px;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n    border: 1px solid rgba(226, 232, 240, 0.8);\n}\n\n.page-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    background: #f1f5f9;\n    border: none;\n    color: #334155;\n    padding: 0.75rem 1.25rem;\n    border-radius: 12px;\n    font-size: 1.1rem;\n    font-weight: 700;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.page-btn:hover:not(:disabled) {\n    background: #e2e8f0;\n    color: #1e293b;\n}\n\n.page-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n\n/* =========================================\n   === MEMBER DETAILS PAGE STYLES ===\n   ========================================= */\n\n.details-top-grid {\n    display: grid;\n    grid-template-columns: 1fr 2fr;\n    gap: 1.5rem;\n    margin-bottom: 2.5rem;\n}\n\n.profile-summary-card {\n    background: white;\n    border-radius: 16px;\n    padding: 2rem;\n    border: 1px solid #e2e8f0;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 1rem;\n}\n\n.profile-avatar {\n    height: 90px;\n    width: 90px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.profile-info h2 {\n    margin: 0 0 0.25rem 0;\n    font-size: 1.5rem;\n    color: #1e293b;\n    font-weight: 800;\n}\n\n.phone-text {\n    margin: 0 0 1rem 0;\n    color: #64748b;\n    font-size: 1.1rem;\n    font-weight: 500;\n}\n\n.global-stats-card {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1rem;\n    width: 100%;\n}\n\n.stat-box {\n    background: white;\n    border-radius: 16px;\n    padding: 1.25rem;\n    border: 1px solid #e2e8f0;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);\n    display: flex;\n    align-items: center;\n    gap: 1.25rem;\n}\n\n/* Net Position Custom Colors */\n.bg-red-light {\n    background: #fef2f2;\n}\n\n.bg-emerald-light {\n    background: #ecfdf5;\n}\n\n.border-emerald {\n    border-color: #a7f3d0;\n}\n\n.border-red {\n    border-color: #fecaca;\n}\n\n.stat-box .stat-icon {\n    height: 56px;\n    width: 56px;\n    border-radius: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.stat-text p {\n    margin: 0 0 0.25rem 0;\n    color: #64748b;\n    font-size: 1rem;\n    font-weight: 600;\n}\n\n.stat-text h3 {\n    margin: 0;\n    font-size: 1.6rem;\n    color: #1e293b;\n    font-weight: 800;\n}\n\n.section-heading {\n    font-size: 1.4rem;\n    color: #1e293b;\n    font-weight: 800;\n    margin: 0 0 1.5rem 0;\n}\n\n.admin-divider {\n    height: 1px;\n    background: #cbd5e1;\n    margin: 0 0 2.5rem 0;\n}\n\n.group-details-list {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n}\n\n.detailed-group-card {\n    background: white;\n    border-radius: 16px;\n    padding: 1.5rem;\n    border: 1px solid #e2e8f0;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);\n}\n\n.group-card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-bottom: 1.25rem;\n    border-bottom: 1px solid #f1f5f9;\n    margin-bottom: 1.25rem;\n}\n\n.group-header-info h3 {\n    margin: 0 0 0.5rem 0;\n    font-size: 1.3rem;\n    color: #1e293b;\n    font-weight: 800;\n}\n\n.group-header-meta {\n    display: flex;\n    gap: 0.5rem;\n}\n\n.meta-pill {\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    color: #475569;\n    padding: 0.3rem 0.8rem;\n    border-radius: 8px;\n    font-size: 0.9rem;\n    font-weight: 600;\n}\n\n.group-financial-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 1rem;\n    margin-bottom: 1.5rem;\n}\n\n.fin-box {\n    background: #f8fafc;\n    padding: 1rem;\n    border-radius: 12px;\n    border: 1px solid #f1f5f9;\n}\n\n.fin-box p {\n    margin: 0 0 0.25rem 0;\n    font-size: 0.9rem;\n    color: #64748b;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n}\n\n.fin-box h4 {\n    margin: 0;\n    font-size: 1.2rem;\n    color: #1e293b;\n    font-weight: 800;\n}\n\n.alert-box {\n    background: #fef2f2;\n    border-color: #fecaca;\n}\n\n.success-box {\n    background: #f0fdf4;\n    border-color: #bbf7d0;\n}\n\n.text-red {\n    color: #dc2626;\n}\n\n.text-blue {\n    color: #2563eb;\n}\n\n.text-emerald {\n    color: #059669;\n}\n\n.toggle-history-btn {\n    width: 100%;\n    background: white;\n    border: 1px solid #cbd5e1;\n    color: #475569;\n    padding: 0.75rem;\n    border-radius: 10px;\n    font-size: 1rem;\n    font-weight: 600;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    transition: all 0.2s;\n}\n\n.toggle-history-btn:hover {\n    background: #f8fafc;\n    color: #1e293b;\n}\n\n.group-history-section {\n    margin-top: 1rem;\n    padding-top: 1rem;\n    border-top: 1px solid #f1f5f9;\n}\n\n.no-history-text {\n    text-align: center;\n    color: #94a3b8;\n    font-style: italic;\n    padding: 1rem;\n}\n\n.mini-history-list {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n}\n\n.mini-tx-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: #f8fafc;\n    padding: 1rem;\n    border-radius: 10px;\n    border: 1px solid #e2e8f0;\n}\n\n.mini-tx-left {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n}\n\n.mini-icon {\n    height: 36px;\n    width: 36px;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.bg-blue-light {\n    background: #eff6ff;\n}\n\n.bg-green-light {\n    background: #f0fdf4;\n}\n\n.mini-tx-info p {\n    margin: 0;\n}\n\n.tx-type {\n    font-weight: 700;\n    color: #1e293b;\n    font-size: 1.05rem;\n    margin-bottom: 0.2rem !important;\n}\n\n.tx-meta {\n    color: #64748b;\n    font-size: 0.85rem;\n}\n\n.italic {\n    font-style: italic;\n    margin-top: 0.2rem !important;\n}\n\n.mini-tx-right {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    font-size: 1.2rem;\n    font-weight: 800;\n}\n\n.pay-mode {\n    font-size: 0.75rem;\n    color: #94a3b8;\n    background: white;\n    padding: 0.1rem 0.5rem;\n    border-radius: 4px;\n    border: 1px solid #e2e8f0;\n    margin-top: 0.25rem;\n    font-weight: 600;\n}\n\n/* === RESPONSIVE FOR MOBILE === */\n@media (max-width: 900px) {\n    .details-top-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .group-financial-grid {\n        grid-template-columns: 1fr 1fr;\n    }\n}\n\n@media (max-width: 768px) {\n    .groups-header {\n        padding: 1.25rem;\n    }\n\n    .members-main-content {\n        padding: 0 1rem 3rem 1rem;\n    }\n\n    .members-control-panel {\n        justify-content: stretch;\n    }\n\n    .admin-search-form {\n        max-width: 100%;\n        width: 100%;\n    }\n\n    .elder-list-card {\n        flex-direction: column;\n        align-items: stretch;\n        padding: 1.25rem;\n        gap: 1.25rem;\n    }\n\n    .list-card-left {\n        width: 100%;\n    }\n\n    .list-card-right {\n        width: 100%;\n        border-top: 1px solid #f1f5f9;\n        padding-top: 1.25rem;\n    }\n\n    .view-details-btn {\n        width: 100%;\n        justify-content: space-between;\n    }\n\n    .elder-pagination {\n        flex-direction: column;\n        gap: 1.5rem;\n    }\n\n    .page-btn {\n        width: 100%;\n        justify-content: center;\n    }\n\n    /* Member Details Mobile */\n    .global-stats-card {\n        grid-template-columns: 1fr;\n        /* Stack vertically on small phones */\n    }\n\n    .group-card-header {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 1rem;\n    }\n\n    .group-financial-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .mini-tx-row {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 1rem;\n    }\n\n    .mini-tx-right {\n        width: 100%;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: center;\n        border-top: 1px solid #e2e8f0;\n        padding-top: 0.75rem;\n    }\n\n    .pay-mode {\n        margin-top: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
